import Vue from "vue";
import init from "./init";

Vue.config.productionTip = false;

init();
